import { create } from 'zustand';

const DEFAULT_PRESETS = [
  { id: 'facebook banner 600x600 px', name: 'facebook banner 600x600 px', width: 600, height: 600 },
  { id: 'default size 500x500 px', name: 'default size 500x500 px', width: 500, height: 500 },
  { id: 'banner 400x500 px', name: 'banner 400x500 px', width: 400, height: 500 },
  { id: 'custom user preset', name: 'custom user preset', customSize: true },
];

const useStageStore = create((set, get) => ({
  stage: null,
  clipOutline: true,
  canvasSize: { width: DEFAULT_PRESETS[0].width, height: DEFAULT_PRESETS[0].height },
  canvasPosition: { x: 0, y: 0 },
  presetsDataSource: DEFAULT_PRESETS,
  preset: undefined,
  selectedElementPosition: { x: 0, y: 0 },

  setStage: (next) =>
    set((state) => {
      if (state.stage && state.stage !== next) {
        try {
          state.stage.destroy();
        } catch {}
      }
      return { stage: next };
    }),
  setClipOutline: (clipOutline) => set({ clipOutline }),
  toggleClipOutline: () => set((s) => ({ clipOutline: !s.clipOutline })),
  setCanvasSize: (canvasSize) => set({ canvasSize }),
  setCanvasPosition: (canvasPosition) => set({ canvasPosition }),
  setPresetsDataSource: (presetsDataSource) => set({ presetsDataSource }),
  setPreset: (preset) => set({ preset }),
  setSelectedElementPosition: (pos) => set({ selectedElementPosition: pos }),

  computeCanvasPosition: (windowWidth, windowHeight, sidebarWidth, marginXOffSet, marginYOffSet, layerDiff) => {
    const { canvasSize } = get();
    set({
      canvasPosition: {
        x: (windowWidth - marginXOffSet - layerDiff - sidebarWidth - canvasSize.width) / 2,
        y: (windowHeight - marginYOffSet - canvasSize.height) / 2,
      },
    });
  },

  reset: () => {
    const prev = get().stage;
    if (prev) {
      try {
        prev.destroy();
      } catch (_) {
        /* ignore */
      }
    }
    return set({
      stage: null,
      clipOutline: true,
      canvasSize: { width: DEFAULT_PRESETS[0].width, height: DEFAULT_PRESETS[0].height },
      canvasPosition: { x: 0, y: 0 },
      preset: undefined,
      selectedElementPosition: { x: 0, y: 0 },
    });
  },
}));

export default useStageStore;
